module.exports = __webpack_public_path__ + "static/media/arrow.48eadde8.png";